import { useTranslation } from "react-i18next";

import ActionButton from "@/components/Button/ActionButton";
import { Text } from "@/components/Typography/Text";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import {
  type AccessiblePath,
  getAccessiblePath,
} from "@/lib/auth/lib/permission-and-role/get-accessible-path";
import { defaultNS } from "@/lib/i18n";

import Icon from "../../Icon/Icon";
import VStack from "../../Layout/VStack";

import { useForbiddenApiErrorDialog } from "./state";

export function ForbiddenApiErrorDialog() {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.ForbiddenApiErrorDialog",
  });

  const { isOpen, props, close } = useForbiddenApiErrorDialog();

  const accessiblePath = getAccessiblePath(
    props?.accessibles?.hasPermissionScopes ?? [],
  );

  const handleGoBackHomeStaff = (path: AccessiblePath) => {
    props?.onGoBack();
    window.location.href = path;
  };

  const handleGoBackHomeIndividual = () => {
    props?.onGoBack();
    window.location.href = "/individual";
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent className="max-w-72 py-9">
        <VStack className="items-center text-center gap-4">
          <Icon
            iconName="BanIcon"
            className="text-destructive size-8 stroke-2"
          />

          <Text variant="h3">{t("title")}</Text>

          {props?.accessibles.hasOperator && accessiblePath == null && (
            <Text
              variant="p"
              className="text-muted-foreground whitespace-pre-wrap"
            >
              {t("noAccessableMessage")}
            </Text>
          )}

          <Text
            variant="p"
            className="text-muted-foreground whitespace-pre-wrap"
          >
            {t("message")}
          </Text>

          {props?.accessibles.hasOperator && accessiblePath && (
            <ActionButton
              variant="outline"
              onClick={() => handleGoBackHomeStaff(accessiblePath)}
              className="w-full"
            >
              {t("goBackHomeStaffButton")}
            </ActionButton>
          )}

          {props?.accessibles.hasIndividual && (
            <ActionButton
              variant="ghost"
              onClick={handleGoBackHomeIndividual}
              className="w-full"
            >
              {t("goBackHomeIndividualButton")}
            </ActionButton>
          )}
        </VStack>
      </DialogContent>
    </Dialog>
  );
}
